<ul>
  @for (item of carousel; track item.url) {
    <li>
      <a href="{{ item.url }}">
        <figure>
          <img [ngSrc]="item.imageUrl" width="300" height="150" alt="" />
          <figcaption>{{ item.label }}</figcaption>
        </figure>
      </a>
    </li>
  }
</ul>
